import { render, staticRenderFns } from "./CsrYouthFootballClass.vue?vue&type=template&id=8e80a2da&scoped=true"
import script from "./CsrYouthFootballClass.vue?vue&type=script&lang=js"
export * from "./CsrYouthFootballClass.vue?vue&type=script&lang=js"
import style0 from "./CsrYouthFootballClass.vue?vue&type=style&index=0&id=8e80a2da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e80a2da",
  null
  
)

export default component.exports